import classNames from 'classnames';
import _ from 'lodash';
import React from 'react';
import Caret from '../components/Caret';
import type { TreeListTopic } from '../topic/toTopicTreeList';
import TemplateSidebarItem from './TemplateSidebarItem';
import styles from './TemplatesSidebarTopic.module.scss';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';

const TOPIC_FRAGMENT = gql(`
  fragment TemplatesSidebarTopic_topic on Topic {
    id
    name
    allPosts(orderBy: UPDATED_AT, type: TEMPLATE) {
      edges {
        node {
          ...TemplateSidebarItem_post
        }
      }
    }
  }
`);

interface TemplatesSidebarTopicProps {
  level: number;
  topic: TreeListTopic<DocumentType<typeof TOPIC_FRAGMENT>>;
  isExpanded: boolean;
  onToggleExpanded: () => void;
  activeTemplateId: string | null;
  onClickTemplate: (id: string) => void;
}

const TemplatesSidebarTopic = ({
  level,
  topic,
  isExpanded,
  onToggleExpanded,
  activeTemplateId,
  onClickTemplate,
}: TemplatesSidebarTopicProps) => {
  const isNestedLeaf =
    topic?.childTopics?.length === 0 && topic?.ancestors?.length > 0;

  const templates = _.compact(topic.allPosts?.edges?.map((edge) => edge?.node));

  return (
    <div className={styles.sidebarTopic}>
      {_.times(level, (index) => (
        <div
          key={index}
          className={classNames(styles.indent, {
            [styles.last]: index === level - 1,
          })}
        />
      ))}
      <div className={styles.content}>
        {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions -- TODO - fix next time this file is edited */}
        <div className={styles.name} onClick={onToggleExpanded}>
          <span>{topic.name}</span>
          {!isNestedLeaf && (
            // eslint-disable-next-line jsx-a11y/no-static-element-interactions -- TODO - fix next time this file is edited
            <div className={styles.caretContainer} onClick={onToggleExpanded}>
              <Caret direction={isExpanded ? 'up' : 'down'} size={10} />
            </div>
          )}
        </div>
        {(isExpanded || isNestedLeaf) && templates.length > 0 && (
          <div className={styles.templates}>
            <div
              className={classNames(styles.indent, styles.templateIndent, {
                [styles.last]: true,
              })}
            />
            <div className={styles.templatesList}>
              {templates.map((template) => (
                <TemplateSidebarItem
                  key={template.id}
                  template={template}
                  active={activeTemplateId === template.id}
                  onClick={() => onClickTemplate(template.id)}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TemplatesSidebarTopic;
